import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

import { buildFileName } from "../../utils";
import { getBase64FromFBUrl } from "../../services/firebase.service";

/**
 * Downloads a PDF file based on the provided data.
 *
 * @param {Object} props - Object containing the data to be used in the PDF.
 * @param {JSX.Element} props.document - The JSX element representing the PDF content.
 * @param {string} props.pdfTitle - The title of the PDF file.
 *
 * @throws {Error} - If the PDF generation fails.
 */
export const handlePdfDownload = async ({ document, pdfTitle }) => {
  try {
    const fileName = buildFileName(pdfTitle, "pdf");

    // Pre-resolve company logo to base64 so @react-pdf/renderer doesn't fetch it (avoids CORS)
    let resolvedDocument = document;
    const company = document?.props?.company;
    if (company?.logoFile?.url) {
      const base64Logo = await getBase64FromFBUrl(company.logoFile.url);
      if (base64Logo) {
        const { cloneElement } = await import("react");
        const resolvedCompany = { ...company, logoFile: { ...company.logoFile, url: base64Logo } };
        resolvedDocument = cloneElement(document, { company: resolvedCompany });
      }
    }

    const blob = await pdf(resolvedDocument).toBlob();
    saveAs(blob, fileName);
  } catch (error) {
    console.error("handlePdfDownload failed:", error);
    throw error;
  }
};
